module.exports = __webpack_public_path__ + "static/media/dinner-back.8fd6de6f.png";